import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import api from '../api/client';

export default function SetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const email    = searchParams.get('email') || '';
  const token    = searchParams.get('token') || '';
  const [form, setForm]     = useState({ password: '', conferma: '' });
  const [error, setError]   = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!email || !token) setError('Link non valido o scaduto.');
  }, [email, token]);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password !== form.conferma) { setError('Le password non coincidono'); return; }
    if (form.password.length < 8) { setError('La password deve essere di almeno 8 caratteri'); return; }
    setLoading(true);
    try {
      await api.post('/auth/set-password', { email, token, password: form.password });
      setSuccess('Password impostata! Reindirizzamento...');
      setTimeout(() => navigate('/login'), 1500);
    } catch(err) {
      setError(err.response?.data?.error || 'Errore');
    } finally { setLoading(false); }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>B-CHEERS ASD</div>
        <div style={s.sub}>IMPOSTA LA PASSWORD</div>
        <p style={s.desc}>Scegli una password per il tuo account <strong style={{ color:'#F4600C' }}>{email}</strong></p>
        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.field}>
            <label style={s.label}>NUOVA PASSWORD</label>
            <input style={s.input} type="password" value={form.password} onChange={set('password')} placeholder="Minimo 8 caratteri" required />
          </div>
          <div style={s.field}>
            <label style={s.label}>CONFERMA PASSWORD</label>
            <input style={s.input} type="password" value={form.conferma} onChange={set('conferma')} placeholder="Ripeti la password" required />
          </div>
          {error   && <div style={s.error}>{error}</div>}
          {success && <div style={s.ok}>{success}</div>}
          <button type="submit" style={{ ...s.btn, opacity: (loading || !email || !token) ? 0.7 : 1 }} disabled={loading || !email || !token}>
            {loading ? 'SALVATAGGIO...' : 'IMPOSTA PASSWORD'}
          </button>
        </form>
        <div style={s.footer}>
          <Link to="/login" style={s.link}>Torna al login</Link>
        </div>
      </div>
    </div>
  );
}

const s = {
  page:   { minHeight:'100vh', background:'var(--bg)', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px' },
  card:   { background:'var(--bg)', border:'1px solid var(--border)', borderRadius:'16px', padding:'48px 40px', width:'100%', maxWidth:'400px' },
  logo:   { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', color:'#F4600C', letterSpacing:'3px', textAlign:'center', marginBottom:'4px' },
  sub:    { fontSize:'var(--font-size-xs)', fontWeight:'700', color:'var(--text-dim)', letterSpacing:'2px', textAlign:'center', marginBottom:'24px' },
  desc:   { color:'var(--text-dim)', fontSize:'var(--font-size-sm)', marginBottom:'24px', lineHeight:'1.6', textAlign:'center' },
  form:   { display:'flex', flexDirection:'column', gap:'16px' },
  field:  { display:'flex', flexDirection:'column', gap:'7px' },
  label:  { fontSize: 'var(--font-size-xs)', letterSpacing:'2px', fontWeight:'700', color:'var(--text-dim)' },
  input:  { background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'10px', padding:'12px 14px', color:'var(--text)', fontSize:'var(--font-size-sm)', outline:'none', width:'100%', boxSizing:'border-box' },
  error:  { background:'#EF444420', border:'1px solid #EF444440', borderRadius:'8px', padding:'10px 14px', color:'#EF4444', fontSize:'var(--font-size-sm)', fontWeight:'600' },
  ok:     { background:'#22c55e20', border:'1px solid #22c55e40', borderRadius:'8px', padding:'10px 14px', color:'#22c55e', fontSize:'var(--font-size-sm)', fontWeight:'600' },
  btn:    { background:'#F4600C', color:'#fff', border:'none', borderRadius:'10px', padding:'14px', fontSize:'var(--font-size-sm)', fontWeight:'700', cursor:'pointer', letterSpacing:'1px', marginTop:'4px' },
  footer: { textAlign:'center', marginTop:'20px', fontSize:'var(--font-size-sm)', color:'var(--text-dim)' },
  link:   { color:'#F4600C', textDecoration:'none', fontWeight:'700' },
};
